// extracted by mini-css-extract-plugin
module.exports = {"colorLavanderBlush":"#FFE5EE"};